"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
require("../../styles/components/card.scss");
/**
 * Card component for displaying content in a contained section
 * @param props - CardProps
 * @returns Card component
 */
const Card = ({ header, children, footer, className = '', variant = 'default', }) => {
    const cardClasses = ['card', `card--${variant}`, className].filter(Boolean).join(' ');
    return ((0, jsx_runtime_1.jsxs)("div", { className: cardClasses, children: [header && (0, jsx_runtime_1.jsx)("div", { className: "card__header", children: header }), (0, jsx_runtime_1.jsx)("div", { className: "card__content", children: children }), footer && (0, jsx_runtime_1.jsx)("div", { className: "card__footer", children: footer })] }));
};
exports.Card = Card;
exports.default = exports.Card;
